module.exports = __webpack_public_path__ + "img/vehicle.12964598.svg";